import { Flex, LoadingSpin, PageContainer } from '@/components/common';
import { SurveyApiType } from '@/configs';
import { useSurvey } from '@/hooks/app';
import { Alert } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SurveysList from '../SurveysList';

export const Elections = () => {

  const [t] = useTranslation(['common', 'survey']);
  const { surveys, fetchSurvey, loading } = useSurvey();
  const type = SurveyApiType.Election;

  useEffect(() => {
    fetchSurvey();
  }, []);

  const electionSurveys = surveys?.filter((survey) => survey.type === type) ?? [];
  const hasElection = electionSurveys.length > 0;

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  if (!hasElection) {
    return (
      <PageContainer title={t(`common:labels.survey-${type}`)}>
        <Alert type="warning" className="flex mx-auto max-h-16 mt-2 text-center" message={t(`common:messages.survey-empty-${type}`)} />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={t(`common:labels.survey-${type}`)}>
      <Flex direction="column" className="max-w-xl mx-auto">
        <SurveysList
          surveys={electionSurveys}
          onIgnore={() => { }}
          showIgnore={false}
          extraSpace
        />
      </Flex>
    </PageContainer>
  );
};

export default Elections;
